export default "__VITE_ASSET__C186fZtC__"